<template>
  <section
    class="main"
    :style="getGradient()"
  >
    <sign-in-button
      class="signin-button"
    />
    <div
      class="center-bkgrnd"
    />
    <landing-hero-banner
      class="hero-banner"
      :servicer="servicer"
    >
      <servicer-wrapper
        :servicer="servicerProfile"
        :partner="partnerProfile"
      />
    </landing-hero-banner>
    <go-mobile-wrapper
      v-if="$vuetify.breakpoint.lgAndUp"
      class="go-mobile-wrapper"
      :servicer="servicerProfile"
    />
    <footer-wrapper
      :servicer="servicerProfile"
      :sac="sac"
    />
    <section class="watermark d-flex justify-center align-center">
      <img
        alt="Partnering with SimpleNexus"
        src="/assets/sn-watermark-4182512dc7396e289a08ea3e564075fe9428043c53304a1824d28a0735482a59.svg"
      >
    </section>
  </section>
</template>

<script>
import SignInButton from './Header/SignInButton.vue'
import LandingHeroBanner from './HeroBanner/LandingHeroBanner.vue'
import ServicerWrapper from './Servicer/ServicerWrapper.vue'
import GoMobileWrapper from './GoMobile/GoMobileWrapper.vue'
import FooterWrapper from './Footer/FooterWrapper.vue'

import { landingPageQuery } from './landingPage.gql'
import { NullServicer, NullPartner } from './Servicer/nullProfile'
import { rgbaFromHexAndOpacity } from '~/assets/javascript/utilityFunctions.js'
import shareBySmsMixin from '../../common/shareBySmsMixin'

export default {
  apollo: {
    publicData: {
      query: landingPageQuery,
      variables () {
        return {
          code: this.$route.params.code
        }
      },
      skip () {
        return this.servicerProfile instanceof NullServicer === false &&
               this.partnerProfile instanceof NullPartner === false
      },
      result ({ data }) {
        this.servicer = data?.publicData?.servicer_profile
        if (this.servicer) {
          this.servicer.initials = this.getInitialsFromName(this.servicer?.full_name)
          this.servicer.title = this.servicer.title || 'Loan Originator'
          this.servicer.phone = this.servicer.phone || this.formatPhone(this.servicer.unformatted_phone)
          this.servicer.profile_img_url = this.servicer.profile_img_url || 'https://simplenexus.com/images/profile_sihlouette.png'
          this.servicer.full_name = `${this.servicer.name} ${this.servicer.last_name}`
          this.$store.servicer = this.servicer
        }
        this.partner = data?.publicData?.partner
        if (this.partner) {
          this.partner.initials = this.getInitialsFromName(this.partner?.full_name)
          this.partner.title = this.partner.title || 'Real Estate Partner'
          // this.partner.phone = this.partner.phone || this.formatPhone(this.partner.unformatted_phone)
          this.partner.profile_img_url = this.partner.profile_img_url || 'https://simplenexus.com/images/profile_sihlouette.png'
          this.partner.full_name = this.partner.full_name ? this.partner.full_name : `${this.partner.name} ${this.partner.last_name}`
        }
        this.themeColor = this.$vuetify.theme.themes.dark.primary = this.servicer?.theme_primary_color
        this.$vuetify.theme.themes.light.primary = this.servicer?.theme_primary_color
      },
      error ({ error }) {
        this.$sentry.captureException(error)
      }
    }
  },
  components: {
    SignInButton,
    LandingHeroBanner,
    ServicerWrapper,
    GoMobileWrapper,
    FooterWrapper
  },
  mixins: [shareBySmsMixin],
  data () {
    return {
      partner: new NullPartner(),
      servicer: new NullServicer(),
      themeColor: '#FFFFFF'
    }
  },
  computed: {
    secondaryColor () {
      return '#FFFFFF'
    },
    servicerProfile () {
      return this.servicer
    },
    partnerProfile () {
      return this.partner
    },
    profileColorLight () {
      return rgbaFromHexAndOpacity(this.themeColor, 0.5)
    },
    profileColorDark () {
      return rgbaFromHexAndOpacity(this.themeColor, 1.0)
    },
    sac () {
      return this.$route.params.code
    }
  },
  methods: {
    getGradient () {
      return `background: linear-gradient(90deg, ${this.profileColorDark} 0.68%, ${this.profileColorLight} 51.8%, ${this.profileColorDark} 100%);`
    },
    getInitialsFromName (name) {
      return name?.split(' ')?.map(i => i.charAt(0))?.join('')?.toUpperCase() ?? ''
    },
    formatPhone (phone) {
      return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
    },
    rgbaFromHexAndOpacity
  }
}
</script>

<style scoped lang="scss">
  @import '~/assets/css/snui';

  .signin-button {
    position: absolute;
    top: 32px;
    right: 32px;
  }
  .main {
    height: 100%;
    padding-top: 360px;
  }
  .center-bkgrnd {
    position: absolute;
    top: 360px;
    background: $sn-gray-01;
    height: calc(100% - 368px);
    width: 100%;
  }
  .hero-banner {
    position: relative;
    margin-top: -200px;
    max-width: 1184px;
  }
  .go-mobile-wrapper {
    margin-top: 76px;
    max-width: 1184px;
  }
  .watermark {
    position: relative;
    margin-bottom: 8px;
    padding-bottom: 30px;
    background-color: $sn-white;
  }

  @media screen and (max-width: $medium-screen-size) {
    .watermark {
      background-color: initial;
    }
  }
</style>
